export enum LinkedCourseType {
  Grant = "grant",
}
